module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-fill-abb69061.svg";